module.exports = __webpack_public_path__ + "res/ic_logout.adc6fd2f57693513ce05240eaa399bb2.png";